var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: ["custom-field-label-pane__editor", _vm.field.field_type] },
    [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.value$,
            expression: "value$",
          },
        ],
        ref: "inputRef",
        staticClass: "pt-ui-input",
        class: {
          error: !_vm.validator.valid,
        },
        attrs: {
          type: "text",
          maxlength: _vm.MAX_NUM_LENGTH,
          placeholder: _vm.$t(
            "PtCustomFieldLabelPane.editor.placeholder." + _vm.field.field_type
          ),
        },
        domProps: { value: _vm.value$ },
        on: {
          blur: _vm.onFinishEdit,
          click: function ($event) {
            $event.stopPropagation()
          },
          keydown: function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            ) {
              return null
            }
            return _vm.onEnter.apply(null, arguments)
          },
          input: function ($event) {
            if ($event.target.composing) {
              return
            }
            _vm.value$ = $event.target.value
          },
        },
      }),
      _vm.validator.error
        ? _c(
            "div",
            { staticClass: "custom-field-label-pane__editor__valid-error" },
            [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.$t(
                      "PtCustomFieldLabelPane.editor.validator." +
                        _vm.field.field_type +
                        "." +
                        _vm.validator.error
                    )
                  ) +
                  " "
              ),
            ]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }